import { Fragment, useState } from "react";
import { CaretDown, CaretRight } from "@phosphor-icons/react";
import { AMOUNT_COLS, PAY_COLS, inr } from "@/lib/serviceInvoiceReport";

const TH = "px-3 py-2 text-left font-mono text-[10px] uppercase tracking-[0.15em] text-ink-muted whitespace-nowrap";
const TD = "px-3 py-2 font-mono text-xs whitespace-nowrap text-right";
const COLS = [...AMOUNT_COLS, ...PAY_COLS];

function InvoiceRows({ invoices }) {
  return invoices.map((i) => (
    <tr key={i.id} className="bg-canvas/60 border-t border-canvas-line" data-testid={`sir-inv-${i.invoice_number}`}>
      <td className="px-3 py-1.5 pl-10 text-xs" colSpan={2}>
        <span className="font-mono">{i.invoice_number}</span> · {i.type}
        <div className="text-[11px] text-ink-muted">{[i.customer_name, i.vehicle_registration_no, i.technician && `Tech: ${i.technician}`, i.advisor && `Adv: ${i.advisor}`].filter(Boolean).join(" · ")}</div>
      </td>
      <td className={TD}>1</td>
      {COLS.map(([k]) => <td key={k} className={TD}>{i[k] ? inr(i[k]) : "—"}</td>)}
    </tr>
  ));
}

export default function ServiceInvoiceDayTable({ days, totals }) {
  const [open, setOpen] = useState({});
  return (
    <div className="border border-canvas-line bg-white overflow-x-auto" data-testid="sir-day-table">
      <table className="w-full text-sm">
        <thead className="bg-canvas border-b border-canvas-line">
          <tr>
            <th className={TH}>Date</th><th className={TH}>Branch</th><th className={`${TH} text-right`}>Inv.</th>
            {COLS.map(([k, l]) => <th key={k} className={`${TH} text-right`}>{l}</th>)}
          </tr>
        </thead>
        <tbody>
          {days.length === 0 && (
            <tr><td colSpan={COLS.length + 3} className="px-4 py-10 text-center text-ink-muted" data-testid="sir-empty">No service invoices for these filters.</td></tr>
          )}
          {days.map((d) => {
            const key = `${d.date}|${d.branch_id}`;
            return (
              <Fragment key={key}>
                <tr onClick={() => setOpen((o) => ({ ...o, [key]: !o[key] }))} className="border-t border-canvas-line cursor-pointer hover:bg-canvas" data-testid={`sir-day-${d.date}`}>
                  <td className="px-3 py-2 text-xs font-semibold whitespace-nowrap">
                    {open[key] ? <CaretDown size={12} className="inline mr-1" /> : <CaretRight size={12} className="inline mr-1" />}{d.date}
                  </td>
                  <td className="px-3 py-2 text-xs">{d.branch_name}</td>
                  <td className={TD}>{d.count}</td>
                  {COLS.map(([k]) => <td key={k} className={`${TD} ${k === "total_invoice_value" ? "font-bold" : ""}`}>{inr(d[k])}</td>)}
                </tr>
                {open[key] && <InvoiceRows invoices={d.invoices} />}
              </Fragment>
            );
          })}
        </tbody>
        {days.length > 0 && (
          <tfoot className="bg-ink text-white">
            <tr data-testid="sir-totals-row">
              <td className="px-3 py-2 text-xs font-bold" colSpan={2}>TOTAL</td>
              <td className={TD}>{totals.count}</td>
              {COLS.map(([k]) => <td key={k} className={`${TD} font-bold`}>{inr(totals[k])}</td>)}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
